import React from 'react';
import DownloadAllButton from '../components/DownloadAllButton';
import Widget from '../components/Widget';
import './Results.css';

/* accept 'apiResults' which contains the real images from R */
const Results = ({ analysisRun, apiResults }) => {

  /* define the widgets inside the function so they can see 'apiResults' */
  const widgets = [
    { 
      id: 'heatmap', 
      title: 'Heatmap Results', 
      color: '#e74c3c', 
      /* If apiResults exists, show the heatmap. Otherwise show nothing. */
      image: apiResults ? apiResults.heatmap : null 
    },
    { 
      id: 'volcano', 
      title: 'Volcano Plot Results', 
      color: '#9b59b6', 
      image: apiResults ? apiResults.volcano : null 
    },
    { 
      id: 'ma', 
      title: 'MA Plot Results', 
      color: '#3498db', 
      image: apiResults ? apiResults.ma : null 
    },
    { 
      id: 'violin', 
      title: 'Violin Plot Results', 
      color: '#2ecc71', 
      image: null 
    },
    { 
      id: 'summary', 
      title: 'Analysis Summary', 
      color: '#00bcd4', 
      image: null 
    }
  ];

  return (
    <div className="results-container">
      {analysisRun && <DownloadAllButton widgets={widgets} />}
      {widgets.map(widget => (
        <Widget key={widget.id} widget={widget} analysisRun={analysisRun} />
      ))}
    </div>
  );
};

export default Results;